import { jsx as _jsx } from "preact/jsx-runtime";
import { Suspense, useCallback, useEffect, useState, } from 'preact/compat';
import { FormProvider, useForm, } from 'react-hook-form';
import { Provider } from 'react-redux';
import { yupResolver } from '@hookform/resolvers/yup';
import { ThemeProvider } from 'styled-components';
import useGlobalEvent from 'beautiful-react-hooks/useGlobalEvent';
import LoadingSpinner from '@widgets/shared/components/LoadingSpinner';
import { StepCompletionProvider } from '@widgets/DayTickets/context/Steps';
import store from '@genericBookings/store';
import { MessageProvider } from '@genericBookings/context/Message';
import { TimeConflictProvider } from '@bookingForm/context/TimeConflicts';
function BookingFormWrapper({ children, schema, defaultValues, options, OptionsCTX, theme, }) {
    const [isComplete, setIsComplete] = useState(false);
    const form = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues,
    });
    const { isMulti, isBuilder, themeName, onComplete: initialOnComplete, redirect, } = options;
    const onPromotionClosed = useGlobalEvent('promotion.closed');
    // I think this comes from offer modal...
    onPromotionClosed(() => {
        // on promo closed...
        if (['modal', 'upsell'].includes(themeName)) {
            setIsComplete(true);
        }
    });
    useEffect(() => {
        if (isComplete) {
            setTimeout(() => {
                setIsComplete(false);
            }, 1);
        }
    }, [isComplete]);
    const handlePageShown = useCallback((e) => {
        if (e.persisted) {
            window.location.reload();
        }
    }, []);
    window.addEventListener('pageshow', handlePageShown);
    if (isComplete && redirect) {
        return null;
    }
    const renderChildren = () => {
        if (isMulti) {
            return (_jsx(TimeConflictProvider, { children: children }));
        }
        return children;
    };
    return (_jsx(Suspense, { fallback: _jsx(LoadingSpinner, {}), children: _jsx(StepCompletionProvider, { isBuilder: isBuilder, children: _jsx(Provider, { store: store, children: _jsx(MessageProvider, { children: _jsx(FormProvider, { ...form, children: _jsx(ThemeProvider, { theme: theme, children: _jsx(OptionsCTX.Provider, { value: {
                                    ...options,
                                    onComplete: () => {
                                        initialOnComplete();
                                        setIsComplete(true);
                                    },
                                }, children: renderChildren() }) }) }) }) }) }) }));
}
export default BookingFormWrapper;
